<template>
  <div>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row id="articles-list">
        <v-col>
          <span class="text-tcdc-green bold header text-uppercase">{{$t('article.article')}}</span>
        </v-col>
      </v-row>
    </template>
    <div v-if="allArticles && allArticles.length > 0">
      <v-row class="mt-6">
        <template v-for="item of allArticles">
          <v-col cols="12" :md="item.highlight ? 12 : 6" :key="item.id.toString()">
            <ArticleCard
                    class="cursor-pointer"
                    :image="item.cover_img_path"
                    :title="item[`subject_${lang}`]"
                    :description="item[`intro_${lang}`]"
                    :date="item.article_date"
                    :viewer="item.article_view"
                    @click.native="articleDetailhandler(item.article_id)"
            />
          </v-col>
        </template>
      </v-row>
      <v-row class="mt-8">
        <v-col class="d-flex flex-1 align-center justify-end">
          <v-pagination
                  v-if="articlePages"
                  total-visible="7"
                  v-model="articlePages.current_page"
                  :length="articlePages.last_page"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  color="#2e8037"
                  @input="(event) => {changePage(event); $vuetify.goTo('#articles-list');}"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <div v-else class="grey--text my-5">
      <div class="text-center">
        {{$t('article.noAnyItem')}}
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from "../../components/cards/ArticleCard";
import GreenLabel from "../../components/buttons/GreenButton";
import { mapState } from "vuex";

export default {
  components: {
    ArticleCard
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.items[0].text = this.branchName;
    if (!this.articlePages) {
      await this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang });
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      articlePages: state => state.Article.allArticles,
      allArticles: state => {
        if (state.Article.allArticles) {
          return state.Article.allArticles.data
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods: {
    articleDetailhandler(id) {
      // console.log("article id", id);
      this.$router.push(`/service/resource-center/article/${id}`);
    },
    changePage(page) {
      this.$store.dispatch('Article/onGetAllArticles', { page: page, lang: this.lang });
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "SERVICE",
        disabled: false,
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "ARTICLE",
        disabled: true
      }
    ],
    articles: [
      { id: "1", title: "", highlight: true },
      { id: "2", title: "", highlight: false },
      { id: "3", title: "", highlight: false },
      { id: "4", title: "", highlight: false },
      { id: "5", title: "", highlight: false }
    ]
  })
};
</script>

<style>
</style>
